import { render, staticRenderFns } from "./NutrientsWater.vue?vue&type=template&id=750e8dcc&scoped=true&"
import script from "./NutrientsWater.vue?vue&type=script&lang=js&"
export * from "./NutrientsWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e8dcc",
  null
  
)

export default component.exports